// 倒计时模板
<template>
  <div class="hint"
    v-text="'页面关闭倒计时：'+ Time +'秒'">
  </div>
</template>

<script>
import { countDown, clearCountDown } from '../../../../static/turnoverCabinet/js/utility'

export default {
  name: 'countDown',
  props: {
    time: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      Time: this.time
    }
  },
  created () {
    let vm = this
    countDown(function () {
      vm.Time--
      console.log('vm.Time', vm.Time)
      // console.log(vm.Time < 0)
      if (vm.Time <= 0) {
        clearCountDown()
        vm.cancelBack()
      }
    })
  },
  mounted () {
  },
  methods: {
    // 返回首页
    cancelBack: function () {
      // return
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet'
      })
      this.$store.state.type = ''
    }
  },
  watch: {
  }
}

</script>

<style  scoped>
.hint{
  text-align: center;
  font-size: 15px;
  color: #ffffff;
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/common/countDown.vue